import React from "react";

function MobilePlaySummary() {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      padding: '15px',
      boxSizing: 'border-box'
    }}>
      <div style={{ 
        color: '#58b047', 
        fontSize: '16px', 
        fontWeight: 'bold', 
        textAlign: 'center', 
        borderBottom: '2px solid #58b047',
        marginBottom: '15px',
        paddingBottom: '5px'
      }}>
        PLAY CHESS
      </div>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '8px',
        marginBottom: '15px',
        width: '100%'
      }}>
        <button style={{
          backgroundColor: '#58b047',
          border: 'none',
          color: 'white',
          padding: '8px 4px',
          fontSize: '11px',
          fontWeight: 'bold',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>1+0</button>
        <button style={{
          backgroundColor: '#58b047',
          border: 'none',
          color: 'white',
          padding: '8px 4px',
          fontSize: '11px',
          fontWeight: 'bold',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>3+0</button>
        <button style={{
          backgroundColor: '#58b047',
          border: 'none',
          color: 'white',
          padding: '8px 4px',
          fontSize: '11px',
          fontWeight: 'bold',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>5+3</button>
        <button style={{
          backgroundColor: '#58b047',
          border: 'none',
          color: 'white',
          padding: '8px 4px',
          fontSize: '11px',
          fontWeight: 'bold',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>10+0</button>
      </div>
      
      <button 
        style={{ 
          background: 'transparent',
          border: '2px solid #58b047',
          color: '#58b047',
          borderRadius: '6px',
          padding: '8px',
          fontSize: '11px',
          fontWeight: 'bold',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          width: '100%',
          textAlign: 'center'
        }}
        onClick={() => {
          window.location.href = '/play';
        }}
        onTouchStart={(e) => {
          e.currentTarget.style.backgroundColor = '#58b047';
          e.currentTarget.style.color = 'white';
        }}
        onTouchEnd={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = '#58b047';
        }}
      >
        MORE GAME<br />SETTINGS
      </button>
    </div>
  );
}

export default MobilePlaySummary;